import React from 'react';

import { Loader } from '.';
import { useAppSelector, useAppDispatch } from 'redux/hooks';
import { setUserRegistrationSteps } from 'redux/users/actions';
import { getCurrentUserSellers } from 'redux/sellers/actions';
import {IframePage} from "../types/iframe";
import {withParamsFrame} from "../HOCs";

const Welcome: React.FC<IframePage> = ({ params }) => {
    const [loaded, setLoaded] = React.useState(false);

    const dispatch = useAppDispatch();

    const { userId, accessToken, registrationSteps, allSellers } = useAppSelector(({ users, sellers }) => ({
        userId: users.currentUser.data.id,
        accessToken: users.currentUser.data.accessToken,
        registrationSteps: users.currentUser.registrationSteps,
        allSellers: sellers.allSellers
    }))

    React.useEffect(() => {
        if(registrationSteps.data?.completeRegistration && userId && accessToken && allSellers.length <= 0) {
            dispatch(getCurrentUserSellers({id: userId}) as any)
        }
    }, [registrationSteps, accessToken, userId])

    React.useEffect(() => {
        const messageHandler = function (e: MessageEvent) {
            if (e.origin === "https://lk.market") {
                if (registrationSteps.data && !registrationSteps.data?.completeRegistration) {
                    dispatch(setUserRegistrationSteps([e.data.progress]))
                }
            }
        }

        window.addEventListener("message", messageHandler);
        return () => window.removeEventListener("message", messageHandler);
    }, [registrationSteps])

    return (
        <div className='xs:mx-3'>
            <div>
                <iframe className={`${!loaded ? 'min-h-[auto]' : 'page-iframe'}`} src={`https://lk.market/welcome${params}`}
                    title="Welcome"
                    width="100%"
                    height={`${loaded ? "calc(100vh-64px)" : "0px"}`}

                    onLoad={() => setLoaded(true)}
                ></iframe>
            </div>
            {
                !loaded && <Loader />
            }
        </div>
    );
}

export default withParamsFrame(Welcome);